export const cubicBezier = 'cubic-bezier(0.22, 0.61, 0.36, 1)'
